export default {
  // Common
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    search: 'Buscar',
    filter: 'Filtrar',
    loading: 'Cargando...',
    noData: 'Sin datos',
    confirm: 'Confirmar',
    close: 'Cerrar',
    yes: 'Sí',
    no: 'No',
    actions: 'Acciones',
    status: 'Estado',
    date: 'Fecha',
    name: 'Nombre',
    description: 'Descripción',
    type: 'Tipo',
    download: 'Descargar',
    upload: 'Subir',
    copy: 'Copiar',
    copied: '¡Copiado!',
    error: 'Error',
    success: 'Éxito',
    warning: 'Advertencia',
    info: 'Información',
    all: 'Todo',
    allTypes: 'Todos los tipos',
    allStatuses: 'Todos los estados',
    none: 'Ninguno',
    active: 'Activo',
    inactive: 'Inactivo',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    refresh: 'Actualizar',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    finish: 'Finalizar',
    submit: 'Enviar',
    confirmDeleteItem: '¿Desea eliminar este elemento?',
    validateForReport: 'Validar para Informe',
    reset: 'Restablecer',
    view: 'Ver',
    details: 'Detalles',
    more: 'Más',
    less: 'Menos',
    today: 'Hoy',
    yesterday: 'Ayer',
    thisWeek: 'Esta semana',
    thisMonth: 'Este mes',
    optional: 'Opcional',
    required: 'Requerido',
    note: 'Nota:',
    and: 'y'
  },

  // Navigation
  nav: {
    dashboard: 'Panel de control',
    scans: 'Escaneos',
    workspaces: 'Workspaces',
    vulnerabilities: 'Vulnerabilidades',
    reports: 'Informes',
    settings: 'Configuración',
    account: 'Mi cuenta',
    logout: 'Cerrar sesión',
    help: 'Ayuda',
    admin: 'Administración',
    tools: 'Herramientas',
    compliance: 'Cumplimiento',
    notifications: 'Notificaciones',
    credentials: 'Credenciales',
    ad: 'Active Directory'
  },

  // Auth
  auth: {
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    register: 'Registrarse',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    magicLink: 'Magic Link',
    resetPassword: 'Restablecer contraseña',
    resetPasswordNeedsLink: 'Para restablecer tu contraseña, utiliza el enlace enviado por correo electrónico. Puedes solicitar un nuevo enlace desde la página de inicio de sesión.',
    rememberMe: 'Recordarme',
    loginSuccess: 'Inicio de sesión exitoso',
    loginError: 'Credenciales incorrectas',
    logoutSuccess: 'Cierre de sesión exitoso',
    sessionExpired: 'Sesión expirada',
    twoFactor: 'Autenticación de dos factores',
    enterCode: 'Ingresa el código',
    verifyCode: 'Verificar código',
    invalidCode: 'Código inválido',
    // Register page
    createAccount: 'Crear una cuenta',
    fillFormBelowEmail: 'Complete el formulario a continuación para crear su cuenta empresarial.',
    companyName: 'Nombre de la empresa',
    companyPlaceholder: 'Su empresa',
    firstName: 'Nombre',
    firstNamePlaceholder: 'Su nombre',
    lastName: 'Apellido',
    lastNamePlaceholder: 'Su apellido',
    professionalEmail: 'Email profesional',
    professionalEmailPlaceholder: 'usted@suempresa.com',
    professionalPhone: 'Teléfono profesional',
    phonePlaceholder: '+34 612 345 678',
    passwordEmailNote: 'Definirá su contraseña después de validar su email.',
    acceptTermsPrefix: 'Acepto los',
    createMyAccount: 'Crear mi cuenta',
    registering: 'Creando...',
    alreadyHaveAccount: '¿Ya tiene una cuenta?',
    loginButton: 'Iniciar sesión',
    byRegistering: 'Al crear una cuenta, acepta nuestros términos de uso y política de privacidad.',
    registrationSuccess: '¡Registro exitoso!',
    registrationEmailSent: 'Se ha enviado un email de confirmación a',
    clickLinkToSetPassword: 'Haga clic en el enlace para establecer su contraseña y activar su cuenta.',
    checkSpam: 'Revise su carpeta de spam si no ve el email.',
    backToLogin: 'Volver al inicio de sesión',
    // Email verification
    verifying: 'Verificando...',
    verifyingDescription: 'Por favor espere mientras verificamos su dirección de email.',
    emailVerified: '¡Email verificado!',
    accountActive: 'Su cuenta está ahora activa.',
    welcome: '¡Bienvenido a SYLink!',
    choosePlan: 'Elegir mi plan',
    redirectingToPlan: 'Redirigiendo a precios en {seconds} segundos...',
    orLoginDirectly: 'O {loginLink} directamente',
    verificationFailed: 'Verificación fallida',
    needNewVerificationLink: '¿Necesita un nuevo enlace de verificación?',
    yourEmail: 'Su email',
    emailSent: '¡Email enviado!',
    resendLink: 'Reenviar enlace',
    invalidLink: 'Enlace inválido',
    requestNewVerificationLink: 'Solicitar un nuevo enlace de verificación',
    sendLink: 'Enviar enlace',
    // Login page
    welcomeBack: '¡Bienvenido de nuevo!',
    enterCredentials: 'Ingrese sus credenciales para acceder a su espacio.',
    loggingIn: 'Iniciando sesión...',
    noAccount: '¿No tiene cuenta?',
    createAccountLink: 'Crear una cuenta',
    createFreeAccount: 'Crear una cuenta gratuita',
    // Password reset
    resetPasswordTitle: 'Restablecer contraseña',
    resetPasswordDesc: 'Ingrese su email para recibir un enlace de restablecimiento.',
    sendResetLink: 'Enviar enlace',
    sending: 'Enviando...',
    resetLinkSent: '¡Enlace enviado!',
    resetLinkSentDesc: 'Revise su correo para restablecer su contraseña.',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar contraseña',
    setNewPassword: 'Establecer contraseña',
    passwordUpdated: '¡Contraseña actualizada!',
    passwordUpdatedDesc: 'Ahora puede iniciar sesión con su nueva contraseña.'
  },

  // Dashboard
  dashboard: {
    title: 'Panel de control',
    welcome: 'Bienvenido, {name}',
    overview: 'Resumen',
    recentScans: 'Escaneos recientes',
    statistics: 'Estadísticas',
    quickActions: 'Acciones rápidas',
    newScan: 'Nuevo escaneo',
    viewAllScans: 'Ver todos los escaneos',
    totalScans: 'Total de escaneos',
    activeScans: 'Escaneos activos',
    completedScans: 'Escaneos completados',
    failedScans: 'Escaneos fallidos',
    vulnerabilitiesFound: 'Vulnerabilidades encontradas',
    criticalVulns: 'Vulnerabilidades críticas',
    highVulns: 'Vulnerabilidades altas',
    mediumVulns: 'Vulnerabilidades medias',
    lowVulns: 'Vulnerabilidades bajas',
    systemHealth: 'Estado del sistema',
    toolsStatus: 'Estado de herramientas',
    cpuUsage: 'Uso de CPU',
    memoryUsage: 'Uso de memoria',
    diskUsage: 'Uso de disco',
    // Service status
    services: {
      backendApi: 'API Backend',
      frontend: 'Frontend',
      postgresql: 'PostgreSQL',
      aiModels: 'Modelos de IA'
    },
    serviceStatus: {
      online: 'En línea',
      offline: 'Fuera de línea',
      checking: 'Verificando',
      degraded: 'Degradado'
    }
  },

  // Scans
  scans: {
    title: 'Escaneos',
    newScan: 'Nuevo escaneo',
    scanHistory: 'Historial de escaneos',
    target: 'Objetivo',
    targets: 'Objetivos',
    scanType: 'Tipo de escaneo',
    startScan: 'Iniciar escaneo',
    stopScan: 'Detener escaneo',
    pauseScan: 'Pausar',
    resumeScan: 'Reanudar',
    deleteScan: 'Eliminar escaneo',
    scanDetails: 'Detalles del escaneo',
    scanResults: 'Resultados del escaneo',
    progress: 'Progreso',
    duration: 'Duración',
    startedAt: 'Iniciado el',
    completedAt: 'Completado el',
    status: {
      waiting: 'En cola',
      pending: 'Pendiente',
      running: 'En ejecución',
      completed: 'Completado',
      failed: 'Fallido',
      cancelled: 'Cancelado',
      paused: 'Pausado'
    },
    types: {
      quick: 'Escaneo rápido',
      full: 'Escaneo completo',
      stealth: 'Escaneo sigiloso',
      aggressive: 'Escaneo agresivo',
      custom: 'Escaneo personalizado',
      iot_scan: 'Escaneo IoT',
      ot_scan: 'Escaneo OT/SCADA',
      full_autonomous: 'Autónomo completo',
      full_auto: 'Autónomo completo',
      full_automation: 'Autónomo completo',
      network_discovery: 'Descubrimiento de red',
      vulnerability_scan: 'Escaneo de vulnerabilidades',
      expert: 'Escaneo experto',
      api_pentest: 'Pentest API',
      ad_pentest: 'Pentest Active Directory',
      ad_scan: 'Escaneo Active Directory',
      wifi_pentest: 'Pentest Wi-Fi',
      social_engineering: 'Ingeniería social',
      red_team: 'Red Team',
      phishing: 'Campaña de phishing'
    },
    phases: {
      discovery: 'Descubrimiento',
      portScan: 'Escaneo de puertos',
      serviceDetection: 'Detección de servicios',
      vulnScan: 'Escaneo de vulnerabilidades',
      exploitation: 'Explotación',
      reporting: 'Informe'
    },
    stealthMode: {
      title: 'Modo Sigiloso',
      description: 'Técnicas de evasión IDS/IPS',
      none: 'Ninguno',
      noneDesc: 'Escaneo rápido, fácilmente detectable',
      basic: 'Básico',
      basicDesc: 'Paquetes fragmentados',
      advanced: 'Avanzado',
      advancedDesc: 'Temporización lenta + spoofing',
      paranoid: 'Paranoico',
      paranoidDesc: 'Evasión máxima (muy lento)',
      warning: 'Los modos sigilosos utilizan técnicas de evasión para evitar la detección IDS/IPS'
    },
    hosts: 'Hosts',
    ports: 'Puertos',
    services: 'Servicios',
    openPorts: 'Puertos abiertos',
    closedPorts: 'Puertos cerrados',
    filteredPorts: 'Puertos filtrados',
    noResults: 'No se encontraron resultados',
    exportResults: 'Exportar resultados',
    scanFailed: 'Escaneo fallido',
    genericError: 'Se produjo un error durante la ejecución del escaneo. Esto puede deberse a problemas de conectividad de red, objetivos inaccesibles o recursos insuficientes.',
    technicalDetails: 'Detalles técnicos',
    retryScan: 'Reintentar este escaneo',
    // Cleanup mode
    cleanup: 'Limpieza',
    cleanupTitle: 'Limpieza post-pentest',
    cleanupDescription: 'Esta acción eliminará todos los rastros dejados por el pentest, incluyendo:',
    cleanupSessions: 'Sesiones de explotación activas',
    cleanupPersistence: 'Mecanismos de persistencia instalados',
    cleanupFiles: 'Archivos temporales y evidencias',
    cleanupLogs: 'Registros de ejecución APT',
    cleanupPreview: 'Vista previa de limpieza',
    sessionsCount: 'Sesiones',
    withPersistence: 'Con persistencia',
    aptExecutions: 'Ejecuciones APT',
    evidenceFiles: 'Archivos de evidencia',
    evidenceSize: 'Tamaño de evidencia',
    cleanNow: 'Limpiar ahora',
    archiveAndClean: 'Archivar y limpiar',
    cleaning: 'Limpiando...',
    cleanupSuccess: 'Limpieza completada con éxito',
    cleanupPartial: 'Limpieza parcial (algunos errores)',
    cleanupFailed: 'Limpieza fallida',
    sessionsClosed: 'Sesiones cerradas',
    persistenceRemoved: 'Persistencia eliminada',
    filesCleaned: 'Archivos limpiados',
    aptLogsCleaned: 'Registros APT limpiados',
    evidenceArchived: 'Evidencia archivada',
    cleanupWarning: '⚠️ Esta acción es irreversible. Asegúrese de haber guardado los datos importantes.'
  },

  // Workspaces
  workspaces: {
    title: 'Espacios de clientes',
    newWorkspace: 'Nuevo espacio',
    editWorkspace: 'Editar espacio',
    deleteWorkspace: 'Eliminar espacio',
    workspaceDetails: 'Detalles del espacio',
    clientName: 'Nombre del cliente',
    clientInfo: 'Información del cliente',
    members: 'Miembros',
    addMember: 'Añadir miembro',
    removeMember: 'Eliminar miembro',
    scansCount: 'Número de escaneos',
    lastActivity: 'Última actividad',
    created: 'Creado el',
    shareWorkspace: 'Compartir espacio',
    archiveWorkspace: 'Archivar espacio',
    noWorkspaces: 'Sin espacios de clientes',
    // Form labels
    siret: 'SIRET',
    siretPlaceholder: 'Ej: 123 456 789 00001',
    siren: 'SIREN',
    sirenPlaceholder: 'Ej: 123 456 789',
    // Additional workspace keys
    scans: 'Escaneos',
    hosts: 'Hosts',
    vulnerabilities: 'Vulnerabilidades',
    attackPaths: 'Rutas de ataque',
    successfulScans: 'Escaneos exitosos',
    company: 'Empresa',
    legalForm: 'Forma jurídica',
    address: 'Dirección',
    city: 'Ciudad',
    website: 'Sitio web',
    shareDescription: 'Comparte este espacio con tus clientes o colaboradores',
    manageShares: 'Gestionar comparticiones',
    mainContact: 'Contacto principal',
    contact: 'Contacto',
    signed: 'Firmado',
    pending: 'Pendiente',
    draft: 'Borrador',
    contractSigned: 'Contrato firmado',
    pendingContract: 'Contrato pendiente',
    noContract: 'Sin contrato',
    noScans: 'Sin escaneos asociados',
    noScansHint: 'Asocie un escaneo existente o inicie uno nuevo desde la página Escaneos',
    noHosts: 'Sin hosts',
    noVulnerabilities: 'Sin vulnerabilidades',
    noAttackPaths: 'Sin rutas de ataque',
    // Network stats
    vulnerable: 'Vulnerables',
    subnets: 'Subredes',
    services: 'Servicios',
    noAttackTree: 'Sin árbol de ataque',
    noVPN: 'Sin VPN configurado',
    // AI Analysis
    aiAnalysis: 'Análisis IA',
    generateSummary: 'Generar resumen',
    launchAiAnalysis: 'Lanzar análisis IA',
    analysisInProgress: 'Análisis en curso...',
    completeAnalysis: 'Análisis completo y Soluciones',
    aggregatedData: 'Datos agregados',
    riskAnalysis: 'Análisis de riesgos',
    clickToGenerateSummary: 'Haz clic en "Generar resumen" para obtener un análisis IA',
    noAnalysisAvailable: 'Ningún análisis disponible',
    clickToLaunchAnalysis: 'Haz clic en el botón de arriba para lanzar el análisis IA',
    launchScanToDiscoverNetwork: 'Lanza un escaneo para descubrir la red',
    critical: 'Críticos',
    high: 'Altos',
    download: 'Descargar',
    deleteStoredCredentials: 'Eliminar credenciales guardadas',
    useStoredCredentials: 'usar credenciales guardadas',
    enterVpnUsername: 'Introduce tu usuario VPN',
    enterVpnPassword: 'Introduce tu contraseña VPN',
    // VPN Modal
    actionPlan: 'Plan de acción y Soluciones',
    noDocuments: 'Ningún documento generado para este workspace',
    reportsWillAppear: 'Los informes aparecerán aquí después de la generación',
    vpnCredentials: 'Credenciales VPN',
    requiresAuthentication: 'requiere autenticación',
    storedCredentials: 'Credenciales guardadas',
    clickToUseCredentials: 'Haz clic en "Conectar" para usar estas credenciales',
    connect: 'Conectar',
    cancel: 'Cancelar',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    saveCredentials: 'Guardar estas credenciales',
    saveCredentialsSecurely: 'Guardar credenciales de forma segura',
    credentialsStorageInfo: 'Las credenciales se cifrarán (AES-256) y se almacenarán en la base de datos. Se utilizarán automáticamente en futuras conexiones VPN.',
    saving: 'Guardando...',
    connecting: 'Conectando...',
    server: 'Servidor',
    protocol: 'Protocolo',
    noVulnsToFix: 'No hay vulnerabilidades que corregir',
    connectionInProgress: 'Conexión en curso...',
    connectionFailed: 'Conexión fallida',
    generateActionPlan: 'Generar plan de acción',
    clickToGenerateActionPlan: 'Haz clic en "Generar plan de acción" para obtener recomendaciones',
    vpnConnected: '¡VPN conectada! IP:',

    // Workspace Switcher
    selectTitle: 'Seleccionar espacio de trabajo',
    selectDescription: 'Elige un espacio de trabajo para continuar',
    searchPlaceholder: 'Buscar espacios de trabajo...',
    noWorkspacesYet: 'Aún no hay espacios de trabajo',
    noResults: 'No hay espacios de trabajo coincidentes',
    createFirst: 'Crear tu primer espacio de trabajo',
    createNew: 'Crear nuevo',
    continue: 'Continuar',
    switchError: 'Error al cambiar de espacio de trabajo',
    scan: 'escaneo',
    scans: 'escaneos',
    select: 'Seleccionar espacio de trabajo',
    manageAll: 'Gestionar espacios de trabajo',
    noWorkspaces: 'No se encontraron espacios de trabajo',
    switching: 'Cambiando...',
    switchSuccess: 'Espacio de trabajo cambiado exitosamente',
    autoSelected: 'Espacio de trabajo seleccionado automáticamente',
    pleaseSelect: 'Por favor selecciona un espacio de trabajo para continuar',
    activeWorkspace: 'Espacio de trabajo activo'
  },

  // Vulnerabilities
  vulnerabilities: {
    title: 'Vulnerabilidades',
    subtitle: 'Análisis y gestión de vulnerabilidades detectadas',
    vulnerability: 'Vulnerabilidad',
    severity: 'Severidad',
    severities: {
      critical: 'Crítica',
      high: 'Alta',
      medium: 'Media',
      low: 'Baja',
      info: 'Informativa'
    },
    cve: 'CVE',
    cvss: 'Puntuación CVSS',
    affected: 'Afectado',
    solution: 'Solución',
    references: 'Referencias',
    evidence: 'Evidencias',
    exploitable: 'Explotable',
    verified: 'Verificado',
    falsePositive: 'Falso positivo',
    validation: {
      confirmed: 'Confirmado explotable',
      theoretical: 'Teórico',
      not_exploitable: 'No explotable',
      unvalidated: 'No validado',
      poc_title: 'Prueba de Concepto',
      narrative: 'Narrativa de explotación',
      exploit_path: 'Ruta de explotación',
      prerequisites: 'Requisitos previos',
    },
    markAsFixed: 'Marcar como corregido',
    noVulnerabilities: 'No se encontraron vulnerabilidades',
    export: 'Exportar vulnerabilidades',
    distributionBySeverity: 'Distribución por Severidad',
    priority: {
      auto: 'Automático',
    },
    // Attack Chain
    attackChain: {
      title: 'Clasificación de Cadenas de Ataque',
      subtitle: 'Análisis de riesgos multi-vulnerabilidades para penetrar el objetivo',
      riskScore: 'Puntuación de riesgo',
      vulnCount: 'vulnerabilidades',
      attackPath: 'Ruta de ataque hacia el objetivo',
      // Chart
      chartTitle: 'Distribución de Vulnerabilidades',
      chartSubtitle: 'Análisis estadístico de CVE detectadas',
      bySeverity: 'Distribución por Severidad',
      keyMetrics: 'Métricas Clave',
      totalVulns: 'Total CVE',
      avgCvss: 'CVSS Promedio',
      criticalHigh: 'Crítico + Alto',
      affectedHosts: 'Hosts Afectados',
      topCves: 'Top CVE por CVSS',
      // Stages
      stages: {
        initialAccess: 'Acceso Inicial',
        privEscalation: 'Escalada de Privilegios',
        persistence: 'Persistencia',
        objective: 'Objetivo'
      },
      exploitVia: 'Explotación vía',
      escalationVia: 'Escalada vía',
      maintenanceVia: 'Persistencia vía',
      fullCompromise: 'Compromiso total del sistema',
      adminAccess: 'Acceso de administrador posible',
      initialSystemAccess: 'Acceso inicial al sistema',
      // Risk Factors
      riskFactors: 'Factores de riesgo',
      factors: {
        multiVuln: 'Multi-vulnerabilidades',
        multiVuln5: '{count} vulns encadenables',
        multiVuln3: '{count} vulns en este host',
        criticalHighCombo: 'Combo Critical + High',
        rce: 'RCE potencial',
        authBypass: 'Bypass auth posible',
        privEsc: 'Escalada de privilegios',
        exposed: 'Servicios expuestos',
        highCvss: 'CVSS promedio {score}'
      },
      // Ratings
      ratingCritical: 'CRÍTICO',
      ratingHigh: 'ALTO',
      ratingMedium: 'MEDIO',
      ratingLow: 'BAJO',
      ratingSafe: 'SEGURO',
      // Details
      criticalPath: 'RUTA CRÍTICA',
      vulnsInChain: 'Vulnerabilidades en esta cadena',
      noChains: 'No se detectaron cadenas de ataque',
      noVulnsDesc: 'No se encontraron vulnerabilidades para analizar rutas de ataque.',
      viewDetails: 'Ver detalles',
      multiVulnWarning: 'Riesgo aumentado: múltiples vulnerabilidades encadenables',
      // Recommendations
      recommendation: 'Recomendación de explotación',
      recoCritical: 'Este objetivo presenta un riesgo crítico. La combinación de {count} vulnerabilidades permite el compromiso total del sistema. Prioridad máxima para remediación.',
      recoHigh: 'Alto riesgo de compromiso. Las vulnerabilidades combinadas ofrecen una ruta de ataque viable. Acción correctiva recomendada lo antes posible.',
      recoMedium: 'Riesgo moderado. Algunas vulnerabilidades podrían encadenarse para explotación. Monitorear y corregir según prioridad.',
      recoLow: 'Riesgo bajo. Las vulnerabilidades presentes tienen impacto limitado y son difíciles de explotar en cadena.',
      // Stats
      criticalPaths: 'Rutas Críticas',
      highRisk: 'Riesgo Alto',
      multiVuln: 'Multi-Vulns (3+)',
      hostsAnalyzed: 'Hosts Analizados',
      avgScore: 'Puntuación Promedio',
      // Info
      infoText: 'Esta clasificación identifica los hosts más vulnerables analizando combinaciones de vulnerabilidades explotables para alcanzar el objetivo de penetración.',
      // Legend
      legendCritical: 'Crítico (80-100)',
      legendHigh: 'Alto (60-79)',
      legendMedium: 'Medio (40-59)',
      legendLow: 'Bajo (20-39)',
      legendSafe: 'Seguro (0-19)'
    }
  },

  // Reports
  reports: {
    title: 'Informes',
    newReport: 'Nuevo informe',
    generateReport: 'Generar informe',
    downloadReport: 'Descargar informe',
    reportType: 'Tipo de informe',
    settings: 'Configuración',
    branding: 'Branding',
    types: {
      executive: 'Informe ejecutivo',
      technical: 'Informe técnico',
      compliance: 'Informe de cumplimiento',
      full: 'Informe completo',
      vulnerability_list: 'Informe de vulnerabilidades',
      redteam: 'Informe Red Team',
      retest: 'Informe de retest',
      multi_campaign: 'Informe multi-campaña',
      active_directory: 'Informe Active Directory',
      data_leak: 'Informe de fugas de datos',
      attack_surface: 'Informe de superficie de ataque'
    },
    format: 'Formato',
    formats: {
      pdf: 'PDF',
      html: 'HTML',
      json: 'JSON',
      csv: 'CSV',
      docx: 'Word (DOCX)',
      xml: 'XML',
      jira: 'Jira',
      servicenow: 'ServiceNow',
      glpi: 'GLPI',
      pptx: 'PowerPoint (PPTX)',
      txt: 'Texto (TXT)',
      xlsx: 'Excel (XLSX)'
    },
    includeEvidence: 'Incluir evidencias',
    includeRemediation: 'Incluir recomendaciones',
    generatedAt: 'Generado el',
    generatedBy: 'Generado por',
    noReports: 'Sin informes',
    // Export modal
    export: {
      title: 'Exportación',
      processing: 'Exportando...',
      generating: 'Generando archivo',
      takingLong: 'Esta operación está tardando más de lo esperado.',
      canWaitOrEmail: 'Puede esperar o cerrar esta ventana y le enviaremos un enlace por correo.',
      sendByEmail: 'Enviar por correo',
      continueWaiting: 'También puede seguir esperando, la descarga comenzará automáticamente.',
      emailSent: '¡Correo enviado!',
      emailSentDesc: 'Recibirá el enlace de descarga por correo en breve.',
      wordLocked: 'Disponible para planes Empresa y superiores'
    }
  },

  // Account
  account: {
    title: 'Mi cuenta',
    profile: 'Perfil',
    security: 'Seguridad',
    subscription: 'Suscripción',
    billing: 'Facturación',
    credits: 'Créditos',
    notifications: 'Notificaciones',
    integrations: 'Integraciones',
    referral: 'Referidos',
    activity: 'Actividad',
    contracts: 'Contratos',

    // Profile section
    profileSection: {
      title: 'Información del perfil',
      avatar: 'Foto de perfil',
      changeAvatar: 'Cambiar foto',
      removeAvatar: 'Eliminar foto',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      company: 'Empresa',
      position: 'Cargo',
      timezone: 'Zona horaria',
      language: 'Idioma del portal',
      languageDescription: 'Elige el idioma de visualización de la interfaz',
      updateSuccess: 'Perfil actualizado con éxito',
      updateError: 'Error al actualizar el perfil'
    },

    // Security section
    securitySection: {
      title: 'Seguridad de la cuenta',
      changePassword: 'Cambiar contraseña',
      currentPassword: 'Contraseña actual',
      newPassword: 'Nueva contraseña',
      confirmPassword: 'Confirmar contraseña',
      passwordRequirements: 'La contraseña debe tener al menos 8 caracteres',
      twoFactorAuth: 'Autenticación de dos factores',
      enable2FA: 'Activar 2FA',
      disable2FA: 'Desactivar 2FA',
      twoFactorEnabled: '2FA activada',
      twoFactorDisabled: '2FA desactivada',
      activeSessions: 'Sesiones activas',
      revokeSession: 'Revocar sesión',
      revokeAllSessions: 'Revocar todas las sesiones',
      loginHistory: 'Historial de inicios de sesión',
      lastLogin: 'Último inicio de sesión',
      apiKeys: 'Claves API',
      generateApiKey: 'Generar clave API',
      deleteApiKey: 'Eliminar clave API'
    },

    // Subscription section
    subscriptionSection: {
      title: 'Suscripción',
      currentPlan: 'Plan actual',
      planDetails: 'Detalles del plan',
      features: 'Funciones incluidas',
      usage: 'Uso',
      limits: 'Límites',
      renewalDate: 'Fecha de renovación',
      cancelSubscription: 'Cancelar suscripción',
      upgradePlan: 'Mejorar plan',
      downgradePlan: 'Reducir plan',
      plans: {
        free: 'Gratuito',
        pro: 'Pro',
        enterprise: 'Empresa',
        dedicated: 'Dedicado'
      }
    },

    // Credits section
    creditsSection: {
      title: 'Gestión de créditos',
      balance: 'Saldo',
      totalCredits: 'Créditos totales',
      monthlyCredits: 'Créditos mensuales',
      packCredits: 'Créditos de paquete',
      usedThisMonth: 'Usados este mes',
      remaining: 'Restantes',
      buyCredits: 'Comprar créditos',
      creditHistory: 'Historial de créditos',
      transaction: 'Transacción',
      amount: 'Cantidad',
      creditCosts: 'Coste de operaciones',
      scanCost: 'Coste de escaneo',
      reportCost: 'Coste de informe'
    },

    // Notifications section
    notificationsSection: {
      title: 'Preferencias de notificaciones',
      emailNotifications: 'Notificaciones por correo',
      pushNotifications: 'Notificaciones push',
      scanCompleted: 'Escaneo completado',
      scanFailed: 'Escaneo fallido',
      newVulnerability: 'Nueva vulnerabilidad crítica',
      reportReady: 'Informe listo',
      securityAlerts: 'Alertas de seguridad',
      weeklyDigest: 'Resumen semanal',
      marketingEmails: 'Correos de marketing'
    },

    // Integrations section
    integrationsSection: {
      title: 'Integraciones',
      connected: 'Conectado',
      notConnected: 'No conectado',
      configure: 'Configurar',
      disconnect: 'Desconectar',
      testConnection: 'Probar conexión',
      connectionSuccess: 'Conexión exitosa',
      connectionFailed: 'Conexión fallida',
      availableIntegrations: 'Integraciones disponibles',
      myIntegrations: 'Mis integraciones'
    },

    // Referral section
    referralSection: {
      title: 'Programa de referidos',
      referralLink: 'Enlace de referido',
      copyLink: 'Copiar enlace',
      shareLink: 'Compartir enlace',
      inviteFriends: 'Invitar amigos',
      referralStats: 'Estadísticas de referidos',
      totalReferrals: 'Total de referidos',
      pendingReferrals: 'Referidos pendientes',
      completedReferrals: 'Referidos completados',
      earnedCredits: 'Créditos ganados',
      inviteByEmail: 'Invitar por correo',
      contacts: 'Contactos invitados',
      rewards: 'Recompensas',
      leaderboard: 'Clasificación'
    }
  },

  // Settings
  settings: {
    title: 'Configuración',
    general: 'General',
    tools: 'Herramientas',
    network: 'Red',
    advanced: 'Avanzado',

    generalSection: {
      title: 'Configuración general',
      defaultScanType: 'Tipo de escaneo predeterminado',
      defaultReportFormat: 'Formato de informe predeterminado',
      autoSaveReports: 'Guardar informes automáticamente',
      enableNotifications: 'Activar notificaciones',
      darkMode: 'Modo oscuro',
      compactView: 'Vista compacta'
    },

    toolsSection: {
      title: 'Configuración de herramientas',
      enabledTools: 'Herramientas habilitadas',
      toolSettings: 'Configuración de herramientas',
      timeout: 'Tiempo de espera',
      threads: 'Número de hilos',
      verbosity: 'Nivel de detalle'
    },

    networkSection: {
      title: 'Configuración de red',
      proxySettings: 'Configuración de proxy',
      vpnSettings: 'Configuración de VPN',
      dnsSettings: 'Configuración de DNS',
      useProxy: 'Usar proxy',
      proxyHost: 'Host del proxy',
      proxyPort: 'Puerto del proxy'
    },

    // Server status
    uptime: 'Tiempo de actividad'
  },

  // Admin
  admin: {
    title: 'Administración',
    users: 'Usuarios',
    companies: 'Empresas',
    system: 'Sistema',
    logs: 'Registros',
    maintenance: 'Mantenimiento',

    usersSection: {
      title: 'Gestión de usuarios',
      addUser: 'Añadir usuario',
      editUser: 'Editar usuario',
      deleteUser: 'Eliminar usuario',
      activateUser: 'Activar usuario',
      deactivateUser: 'Desactivar usuario',
      resetPassword: 'Restablecer contraseña',
      role: 'Rol',
      roles: {
        admin: 'Administrador',
        user: 'Usuario',
        viewer: 'Observador'
      },
      lastLogin: 'Último inicio de sesión',
      createdAt: 'Creado el',
      noUsers: 'Sin usuarios'
    },

    systemSection: {
      title: 'Sistema',
      systemInfo: 'Información del sistema',
      version: 'Versión',
      uptime: 'Tiempo de actividad',
      restart: 'Reiniciar',
      backup: 'Copia de seguridad',
      restore: 'Restaurar',
      update: 'Actualizar'
    }
  },

  // Errors
  errors: {
    generic: 'Ha ocurrido un error',
    notFound: 'Página no encontrada',
    unauthorized: 'Acceso no autorizado',
    forbidden: 'Acceso prohibido',
    serverError: 'Error del servidor',
    networkError: 'Error de red',
    timeout: 'Tiempo de espera agotado',
    validation: 'Error de validación',
    invalidEmail: 'Correo electrónico inválido',
    invalidPassword: 'Contraseña inválida',
    passwordMismatch: 'Las contraseñas no coinciden',
    requiredField: 'Este campo es requerido',
    minLength: 'Se requieren mínimo {min} caracteres',
    maxLength: 'Se permiten máximo {max} caracteres',
    fillAllFields: 'Por favor complete todos los campos requeridos',
    emailAlreadyUsed: 'Este email ya está en uso',
    companyAlreadyRegistered: 'Esta empresa ya está registrada',
    registrationError: 'Error durante el registro',
    genericError: 'Ocurrió un error inesperado',
    disposableEmailNotAllowed: 'Los emails temporales no están permitidos',
    personalEmailNotAllowed: 'El email {domain} no está permitido. Use un email profesional.',
    invalidResetLink: 'Este enlace de restablecimiento es inválido o ha expirado. Por favor, solicite un nuevo enlace.',
    resetLinkExpired: 'Este enlace de restablecimiento ha expirado. Por favor, solicite un nuevo enlace.',
    resetPasswordFailed: 'Error al restablecer la contraseña. Por favor, inténtelo de nuevo.',
    passwordCriteriaNotMet: 'La contraseña no cumple todos los criterios requeridos.'
  },

  // Success messages
  success: {
    saved: 'Guardado con éxito',
    deleted: 'Eliminado con éxito',
    updated: 'Actualizado con éxito',
    created: 'Creado con éxito',
    copied: 'Copiado al portapapeles',
    sent: 'Enviado con éxito',
    uploaded: 'Subido con éxito'
  },

  // Time
  time: {
    now: 'Ahora',
    seconds: 'segundos',
    minutes: 'minutos',
    hours: 'horas',
    days: 'días',
    weeks: 'semanas',
    months: 'meses',
    years: 'años',
    ago: 'hace',
    in: 'en'
  },

  // Credentials
  credentials: {
    title: 'Credenciales',
    username: 'Usuario',
    password: 'Contraseña',
    hash: 'Hash',
    domain: 'Dominio',
    source: 'Fuente',
    foundAt: 'Encontrado el',
    noCredentials: 'No se encontraron credenciales',
    export: 'Exportar credenciales'
  },

  // Sessions
  sessions: {
    title: 'Sesiones',
    sessionDetails: 'Detalles de sesión',
    activeSession: 'Sesión activa',
    closedSession: 'Sesión cerrada',
    sessionType: 'Tipo de sesión',
    target: 'Objetivo',
    startedAt: 'Iniciado en',
    endedAt: 'Finalizado en',
    duration: 'Duración',
    commands: 'Comandos',
    noSessions: 'Sin sesiones',
    closeSession: 'Cerrar sesión',
    quickActions: 'Acciones rápidas',
    quickCommands: 'Comandos rápidos',
    defaultSessionType: 'Terminal',
    sessionLabel: 'Sesión'
  },

  // Attack
  attack: {
    title: 'Centro de Ataque',
    description: 'Herramientas de ataque avanzadas y orquestador dinámico',
    selectTarget: 'Seleccionar objetivo',
    selectTechnique: 'Seleccionar técnica',
    launchAttack: 'Lanzar ataque',
    attackInProgress: 'Ataque en progreso',
    attackCompleted: 'Ataque completado',
    attackFailed: 'Ataque fallido',
    techniques: 'Técnicas',
    payloads: 'Cargas útiles',
    results: 'Resultados',
    dynamicOrchestrator: 'Orquestador Dinámico',
    attackGraph: 'Grafo de Ataque',
    attackBuilder: 'Constructor de Ataque'
  },
  // Active Directory
  ad: {
    title: 'Active Directory',
    description: 'Herramientas de ataque AD con asistencia IA LLM y PoC automatizado',
    domain: 'Dominio',
    dcIp: 'IP del Controlador de Dominio',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    ntlmHash: 'Hash NTLM (opcional)',
    dcConfiguration: 'Configuración del Controlador de Dominio',
    attacks: 'Ataques AD',
    ldapPentest: 'Pentest LDAP/LDAPS',
    searchPlaceholder: 'Buscar un ataque, una herramienta...',
    allCategories: 'Todas las categorías',
    attackCategories: 'Categorías de Ataques',
    targetResults: 'Objetivo / Resultados',
    noDataMessage: 'Seleccione un ataque para comenzar',
    noDataHint: 'O use Auto PoC para una cadena de ataques',
    readyToStart: 'Listo para comenzar',
    stats: {
      attacks: 'Ataques',
      successful: 'Exitosos',
      failed: 'Fallidos',
      credentials: 'Credenciales',
      users: 'Usuarios',
      paths: 'Rutas'
    }
  },

  // Branding (Login/Register pages)
  branding: {
    platformTitle: 'Plataforma de',
    platformSubtitle: 'Pentest Autónomo',
    platformDescription: 'Análisis de seguridad impulsado por IA con explotación automatizada e informes detallados.'
  },

  // Features (Login/Register pages)
  features: {
    autonomousAI: {
      title: 'IA Autónoma',
      description: 'Inteligencia artificial que simula un pentester experto',
      highlight: 'SYLink LLM On-Premise'
    },
    advancedDetection: {
      title: 'Detección Avanzada',
      description: 'Identificación automática de vulnerabilidades críticas',
      highlight: '200K+ CVE'
    },
    completeTests: {
      title: 'Pruebas Completas',
      description: 'Escaneos de red, web, API e infraestructura',
      highlight: '100+ Herramientas'
    },
    instantReports: {
      title: 'Informes Instantáneos',
      description: 'Generación automática de informes PDF profesionales',
      highlight: 'Exportar PDF'
    }
  },

  // Stats (Login/Register pages)
  stats: {
    availability: 'Disponibilidad',
    vulnerabilities: 'Vulnerabilidades detectadas',
    monitoring: 'Monitoreo',
    scanTime: 'Tiempo promedio de escaneo'
  },

  // Footer
  footer: {
    title: 'Plataforma de Escáner de Seguridad',
    subtitle: 'Sistema Autónomo de Pruebas de Penetración',
    terms: 'Términos de Uso',
    sales: 'Términos de Venta',
    privacy: 'Política de Privacidad',
    legalNotice: 'Aviso Legal',
    contact: 'Contacto',
    version: 'Versión',
    licence: 'Licencia n°'
  },

  // Enrichment - ABSpider Integration
  enrichment: {
    title: 'Enriquecimiento & Inteligencia de Amenazas',
    subtitle: 'Análisis avanzado de dominios e IPs con VirusTotal, headers de seguridad, email y geolocalización',
    newScan: 'Nuevo escaneo',
    quickScan: 'Escaneo rápido',
    fullScan: 'Escaneo completo',
    viewDetails: 'Ver detalles',
    exportReport: 'Exportar informe',
    refresh: 'Actualizar',
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'Headers de seguridad',
      security_headers: 'Headers de seguridad',
      email_security: 'Seguridad de email',
      geoip: 'Geolocalización IP',
      reverse_ip: 'Reverse IP',
      full: 'Escaneo completo'
    },
    status: {
      pending: 'Pendiente',
      running: 'En ejecución',
      completed: 'Completado',
      failed: 'Fallido',
      cancelled: 'Cancelado'
    },
    threatLevels: {
      safe: 'Seguro',
      low: 'Bajo',
      medium: 'Medio',
      high: 'Alto',
      critical: 'Crítico'
    },
    form: {
      targetDomain: 'Dominio objetivo',
      targetDomainPlaceholder: 'ej: example.com',
      targetIp: 'Dirección IP (opcional)',
      targetIpPlaceholder: 'ej: 192.168.1.1',
      scanType: 'Tipo de escaneo',
      workspace: 'Workspace (opcional)',
      startScan: 'Iniciar escaneo',
      credits: 'Créditos requeridos'
    },
    results: {
      title: 'Resultados',
      noResults: 'Sin resultados disponibles',
      loading: 'Cargando resultados...',
      riskScore: 'Puntuación de riesgo',
      threatLevel: 'Nivel de amenaza',
      scannedAt: 'Escaneado el',
      duration: 'Duración'
    },
    headers: {
      title: 'Análisis de headers de seguridad',
      score: 'Puntuación',
      grade: 'Calificación',
      present: 'Presentes',
      missing: 'Faltantes',
      recommendations: 'Recomendaciones',
      headerName: 'Header',
      value: 'Valor',
      status: 'Estado',
      issues: 'Problemas'
    },
    email: {
      title: 'Seguridad de email',
      mxRecords: 'Registros MX',
      spf: 'SPF',
      dkim: 'DKIM',
      dmarc: 'DMARC',
      valid: 'Válido',
      invalid: 'Inválido',
      notFound: 'No encontrado',
      policy: 'Política',
      vulnerabilities: 'Vulnerabilidades detectadas',
      recommendations: 'Recomendaciones'
    },
    geoip: {
      title: 'Geolocalización IP',
      location: 'Ubicación',
      country: 'País',
      region: 'Región',
      city: 'Ciudad',
      timezone: 'Zona horaria',
      isp: 'ISP',
      organization: 'Organización',
      isProxy: 'Proxy detectado',
      isVpn: 'VPN detectado',
      isTor: 'Tor detectado'
    },
    virustotal: {
      title: 'Análisis VirusTotal',
      reputation: 'Reputación',
      malicious: 'Malicioso',
      suspicious: 'Sospechoso',
      harmless: 'Inofensivo',
      undetected: 'No detectado'
    },
    errors: {
      scanFailed: 'El escaneo falló',
      insufficientCredits: 'Créditos insuficientes',
      invalidDomain: 'Dominio inválido',
      networkError: 'Error de red'
    }
  },

  // Support
  support: {
    title: 'Soporte',
    myTickets: 'Mis Tickets de Soporte',
    manageRequests: 'Gestione sus solicitudes de asistencia',
    newTicket: 'Nuevo ticket',
    ticketDetails: 'Detalles del ticket',
    subject: 'Asunto',
    message: 'Mensaje',
    priority: 'Prioridad',
    status: 'Estado',
    category: 'Categoría',
    created: 'Creado',
    createdOn: 'Creado el',
    updated: 'Última actualización',
    resolved: 'Resuelto',
    resolvedOn: 'Resuelto el',
    noTickets: 'Sin tickets',
    noTicketsFound: 'No se encontraron tickets',
    noTicketsYet: 'Aún no ha creado ningún ticket de soporte',
    tryModifyingSearch: 'Intente modificar sus criterios de búsqueda',
    createFirstTicket: 'Crear mi primer ticket',
    sendMessage: 'Enviar mensaje',
    send: 'Enviar',
    sending: 'Enviando...',
    closeTicket: 'Cerrar ticket',
    closing: 'Cerrando...',
    ticketClosed: 'Este ticket está cerrado. Para una nueva solicitud, cree un nuevo ticket.',
    search: 'Buscar un ticket...',
    allStatuses: 'Todos los estados',
    refresh: 'Actualizar',
    backToTickets: 'Volver a los tickets',
    ticketNumber: 'Número',
    you: 'Usted',
    supportTeam: 'Soporte SYLink',
    system: 'Sistema',
    writeReply: 'Escriba su respuesta...',
    detailedDescription: 'Descripción detallada',
    informations: 'Información',
    needHelp: '¿Necesita ayuda?',
    responseTime: 'Tiempo de respuesta estimado',
    responseTimeDesc: 'Nuestro equipo generalmente responde dentro de las 24 horas hábiles. Los tickets urgentes se tratan con prioridad.',
    supportResponseDesc: 'Nuestro equipo de soporte generalmente responde dentro de las 24 horas hábiles.',
    newTicketTitle: 'Nuevo Ticket',
    newTicketDesc: 'Describa su problema y nuestro equipo le responderá rápidamente',
    describeIssue: 'Describa brevemente su problema...',
    relatedWorkspace: 'Cliente / Workspace relacionado (opcional)',
    noSpecificWorkspace: 'Ningún workspace específico',
    detailedDescPlaceholder: 'Describa su problema en detalle...',
    charactersCount: '{count} caracteres',
    charactersMin: '{count} caracteres (mínimo {min})',
    cancel: 'Cancelar',
    createTicket: 'Crear ticket',
    creating: 'Creando...',
    rateSupport: '¿Cómo califica la calidad de nuestro soporte?',
    comment: 'Comentario (opcional)...',
    confirm: 'Confirmar',
    messages: 'mensaje',
    messagesPlural: 'mensajes',
    resolutionNotes: 'Notas de resolución',
    yourRating: 'Su calificación',
    statuses: {
      open: 'Abierto',
      in_progress: 'En curso',
      waiting_customer: 'Esperando su respuesta',
      waiting_internal: 'En tratamiento',
      resolved: 'Resuelto',
      closed: 'Cerrado'
    },
    priorities: {
      low: 'Baja',
      medium: 'Media',
      high: 'Alta',
      urgent: 'Urgente',
      lowDesc: 'No urgente, puede esperar',
      mediumDesc: 'Importancia normal',
      highDesc: 'Requiere atención rápida',
      urgentDesc: 'Impacto crítico en la actividad',
      priority: 'Prioridad'
    },
    categories: {
      technical: 'Técnico',
      billing: 'Facturación',
      feature_request: 'Solicitud de función',
      bug_report: 'Informe de error',
      account: 'Cuenta',
      security: 'Seguridad',
      other: 'Otro',
      technicalDesc: 'Problemas técnicos, errores, mal funcionamiento',
      billingDesc: 'Preguntas sobre facturas, pagos, suscripciones',
      feature_requestDesc: 'Sugerencias de mejora o nuevas funciones',
      bug_reportDesc: 'Informar de un error o comportamiento inesperado',
      accountDesc: 'Gestión de cuenta, acceso, permisos',
      securityDesc: 'Preguntas o preocupaciones de seguridad',
      otherDesc: 'Otro tipo de solicitud'
    },
    errors: {
      loadingTickets: 'Error al cargar los tickets',
      loadingTicket: 'Error al cargar el ticket',
      sendingMessage: 'Error al enviar el mensaje',
      closingTicket: 'Error al cerrar el ticket',
      creatingTicket: 'Error al crear el ticket',
      ticketNotFound: 'Ticket no encontrado',
      retry: 'Reintentar',
      fixFormErrors: 'Por favor corrija los errores en el formulario',
      subjectRequired: 'El asunto es requerido',
      subjectMinLength: 'El asunto debe tener al menos 5 caracteres',
      descriptionRequired: 'La descripción es requerida',
      descriptionMinLength: 'La descripción debe tener al menos 20 caracteres'
    },
    success: {
      ticketCreated: 'Ticket {number} creado con éxito',
      messageSent: 'Mensaje enviado',
      ticketClosed: 'Ticket cerrado con éxito'
    }
  },

  // Pricing
  pricing: {
    title: 'Elija su plan',
    subtitle: 'Soluciones de seguridad adaptadas a todos los tamaños de empresa.',
    monthly: 'Mensual',
    yearly: 'Anual',
    yearlyDiscount: '-17%',
    perMonth: 'mes',
    perYear: 'año',
    ht: 'Sin IVA',
    or: 'O sea',
    perMonthShort: '/mes',
    onQuote: 'Bajo presupuesto',
    free: 'Gratis',
    plans: {
      gratuit: {
        name: 'Gratis',
        subtitle: 'Descubrimiento',
        description: 'Ideal para probar la plataforma',
        cta: 'Comenzar gratis'
      },
      pro: {
        name: 'Pro',
        subtitle: 'El más popular',
        description: 'Para profesionales y PYMES',
        cta: 'Elegir Pro',
        badge: 'Recomendado'
      },
      entreprise: {
        name: 'Empresa',
        subtitle: 'Para grandes equipos',
        description: 'Funciones avanzadas y soporte dedicado',
        cta: 'Elegir Empresa'
      },
      entreprise_plus: {
        name: 'Grupo',
        subtitle: 'Para grandes organizaciones',
        description: 'Volumen extendido y soporte premium',
        cta: 'Elegir Grupo'
      },
      sur_mesure: {
        name: 'A medida',
        subtitle: 'Solución personalizada',
        description: 'Adaptada a sus necesidades específicas',
        cta: 'Contáctenos'
      }
    },
    features: {
      simulationOnly: 'Solo modo simulación',
      oneUser: '1 usuario',
      oneTarget: '1 objetivo de prueba',
      basicDashboard: 'Dashboard básico',
      realScans: 'Escaneos reales',
      pdfReports: 'Informes PDF',
      technicalSupport: 'Soporte técnico',
      apiAccess: 'Acceso API',
      unlimitedScans: 'Escaneos IA ilimitados',
      fiveUsers: '5 usuarios',
      tenTargets: '10 objetivos',
      customPdfReports: 'Informes PDF personalizados',
      credentialSearch: 'Búsqueda de credenciales',
      autoScheduling: 'Programación automática',
      prioritySupport: 'Soporte prioritario',
      allProFeatures: 'Todo el plan Pro +',
      fifteenUsers: '15 usuarios',
      thirtyTargets: '30 objetivos',
      ssoSaml: 'SSO / SAML',
      complianceAudit: 'Auditoría de cumplimiento',
      slaGuarantee: 'SLA garantizado 99.9%',
      dedicatedSupport: 'Soporte dedicado',
      teamTraining: 'Formación del equipo incluida',
      allEnterpriseFeatures: 'Todo el plan Empresa +',
      unlimitedUsers: 'Usuarios ilimitados',
      fiftyTargets: '50 objetivos',
      advancedWorkspaces: 'Multi-workspaces avanzados',
      whiteLabelReports: 'Informes white-label',
      support24_7: 'Soporte dedicado 24/7',
      accountManager: 'Account manager dedicado',
      customOnboarding: 'Onboarding personalizado',
      allEnterprisePlusFeatures: 'Todo el plan Grupo +',
      dedicatedInfra: 'Infraestructura dedicada',
      customIntegrations: 'Integraciones personalizadas',
      specificDevelopment: 'Desarrollos específicos',
      sourceCodeAudit: 'Auditoría de código fuente',
      manualPentest: 'Pruebas de intrusión manuales',
      cissoSupport: 'Acompañamiento CISO',
      customContract: 'Contrato a medida'
    },
    whyChoose: '¿Por qué elegir SYLink Pentest?',
    aiTitle: 'Inteligencia Artificial',
    aiDesc: 'Nuestra IA analiza y explota las vulnerabilidades de forma autónoma.',
    securityTitle: 'Seguridad Máxima',
    securityDesc: 'Sus datos están cifrados y seguros.',
    reportsTitle: 'Informes Detallados',
    reportsDesc: 'Genere informes PDF profesionales con recomendaciones.',
    faqTitle: 'Preguntas frecuentes',
    faqCanChangePlan: '¿Puedo cambiar de plan?',
    faqCanChangePlanAnswer: 'Sí, puede actualizar o degradar su plan en cualquier momento.',
    faqFreePlan: '¿Cómo funciona el plan gratuito?',
    faqFreePlanAnswer: 'El plan gratuito le permite probar la plataforma en modo simulación.',
    faqCommitment: '¿Hay algún compromiso?',
    faqCommitmentAnswer: 'No, sin compromiso. Puede cancelar en cualquier momento.',
    faqSupport: '¿Qué soporte está incluido?',
    faqSupportAnswer: 'El plan Pro incluye soporte prioritario por correo electrónico.',
    needHelpChoosing: '¿Necesita ayuda para elegir?',
    needHelpDesc: 'Nuestro equipo está disponible para asesorarle.',
    contactUs: 'Contáctenos',
    requestCall: 'Solicitar una llamada',
    welcomeTitle: '¡Bienvenido a SYLink Pentest!',
    welcomeDesc: 'Su cuenta está activada. Elija el plan que corresponda a sus necesidades.',
    paymentError: 'Error de pago',
    close: 'Cerrar',
    redirecting: 'Redirigiendo...',
    securedByStripe: 'Pago seguro por Stripe'
  },

  // Notifications
  notifications: {
    managementCenter: 'Centro de gestión de alertas y eventos',
    aiAssistant: 'Asistente IA',
    aiAssistantTitle: 'Asistente IA - Notificaciones',
    aiPlaceholder: 'Haga una pregunta sobre sus notificaciones...',
    settings: 'Configuración de notificaciones',
    soundEnabled: 'Sonidos activados',
    criticalOnly: 'Solo críticas',
    autoMarkRead: 'Marcar como leído automáticamente',
    filters: 'Filtros',
    total: 'Total',
    unread: 'No leídas',
    critical: 'Críticas',
    warning: 'Advertencia',
    success: 'Éxito',
    info: 'Info',
    markAllRead: 'Marcar todo como leído',
    clearAll: 'Borrar todo',
    noNotifications: 'Sin notificaciones',
    noNotificationsDesc: 'No tiene ninguna notificación por el momento',
    allRead: 'Todas sus notificaciones están leídas',
    noNotificationsType: 'Sin notificaciones de tipo "{type}"',
    typeCritical: 'Crítica',
    typeWarning: 'Advertencia',
    typeSuccess: 'Éxito',
    typeInfo: 'Info',
    criticalVulnsFound: '{count} vulnerabilidad(es) crítica(s)',
    vulnsDetected: '{count} vulnerabilidad(es) detectada(s)',
    hostsScanned: '{count} hosts escaneados en {target}',
    scanCompletedNoVulns: 'Escaneo completado - Sin vulnerabilidades',
    noVulnsDetected: 'Ninguna vulnerabilidad detectada en {target}',
    scanInProgress: 'Escaneo en curso',
    analyzing: 'Analizando {target}...',
    scanFailed: 'Escaneo fallido',
    errorOn: 'Error en {target}',
    justNow: 'Ahora mismo',
    minutesAgo: 'hace {count}min',
    hoursAgo: 'hace {count}h',
    daysAgo: 'hace {count}d',
    scanRunning: 'Escaneo en curso',
    viewAll: 'Ver todas las notificaciones',
    scanCompleted: 'Escaneo completado'
  },

  // Antivirus (ClamAV)
  antivirus: {
    title: 'Escáner Antivirus',
    subtitle: 'Analizar archivos contra malware con ClamAV',
    adminTitle: 'Gestión Antivirus',
    adminSubtitle: 'Monitorear ClamAV y gestionar cuarentena',
    scannerTab: 'Escáner de Archivos',
    adminTab: 'Administración',

    // File Upload
    dropzone: 'Arrastra un archivo aquí o haz clic para subir',
    dropzoneActive: 'Suelta el archivo aquí...',
    scanning: 'Escaneando...',
    uploadAndScan: 'Subir y Escanear',
    maxFileSize: 'Tamaño máximo de archivo: {size}',

    // Scan Results
    scanResult: 'Resultado del escaneo',
    clean: 'Limpio',
    infected: 'Infectado',
    error: 'Error',
    pending: 'Pendiente',
    threatDetected: 'Amenaza detectada',
    noThreatsFound: 'No se encontraron amenazas',
    threatName: 'Nombre de la amenaza',
    scanTime: 'Tiempo de escaneo',
    fileHash: 'Hash del archivo',

    // History
    scanHistory: 'Historial de escaneos',
    noScansYet: 'Sin escaneos todavía',
    noScansYetDesc: 'Sube un archivo para comenzar a escanear',

    // Admin Dashboard
    clamavStatus: 'Estado de ClamAV',
    version: 'Versión',
    signatureCount: 'Número de firmas',
    lastUpdate: 'Última actualización',
    databaseStatus: 'Estado de la base de datos',
    upToDate: 'Actualizado',
    outdated: 'Desactualizado',

    // Statistics
    statistics: 'Estadísticas',
    totalScans: 'Total de escaneos',
    cleanFiles: 'Archivos limpios',
    infectedFiles: 'Archivos infectados',
    errorScans: 'Escaneos con error',

    // Quarantine
    quarantine: 'Cuarentena',
    quarantineEmpty: 'Cuarentena vacía',
    quarantineEmptyDesc: 'No hay archivos en cuarentena',
    deleteFromQuarantine: 'Eliminar de cuarentena',
    cleanupQuarantine: 'Limpiar cuarentena',

    // Errors
    uploadError: 'Error al subir el archivo',
    scanError: 'Error al escanear el archivo',
    fileTooLarge: 'El archivo es demasiado grande',
    invalidFileType: 'Tipo de archivo no válido',
    serviceUnavailable: 'Servicio antivirus no disponible'
  },

  // Contracts
  contracts: {
    title: 'Contratos',
    contract: 'Contrato',
    newContract: 'Nuevo contrato',
    createContract: 'Crear contrato',
    editContract: 'Editar contrato',
    contractNumber: 'Número de contrato',
    contractTitle: 'Título',

    // Status
    status: {
      draft: 'Borrador',
      pending_signature: 'Pendiente de firma',
      signed: 'Firmado',
      active: 'Activo',
      completed: 'Completado',
      expired: 'Expirado',
      cancelled: 'Cancelado'
    },

    // Provider
    provider: 'Proveedor',
    providerInfo: 'Información del proveedor',
    providerName: 'Nombre de la empresa',
    providerSiret: 'SIRET',
    providerAddress: 'Dirección',

    // Client
    client: 'Cliente',
    clientInfo: 'Información del cliente',
    clientName: 'Nombre de la empresa',
    clientRepresentative: 'Representante del cliente',
    clientContact: 'Contacto',

    // Perimeter
    perimeter: 'Perímetro',
    perimeterDescription: 'Rangos de IP y objetivos a probar',
    addPerimeterItem: 'Añadir elemento al perímetro',

    // Period
    interventionPeriod: 'Período de intervención',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    riskPeriod: 'Período de riesgo (días)',

    // Signature
    signature: {
      title: 'Firma electrónica',
      sign: 'Firmar',
      signed: 'Firmado',
      pendingSignature: 'Pendiente de firma',
      signContract: 'Firmar contrato',
      signatureType: 'Tipo de firma',
      typed: 'Escrita',
      drawn: 'Dibujada',
      uploaded: 'Subida',

      // Signatory
      signatory: 'Firmante',
      signatoryInfo: 'Identidad del firmante',
      signatoryFirstName: 'Nombre',
      signatoryLastName: 'Apellido',
      signatoryEmail: 'Correo electrónico',
      signatoryFullName: 'Nombre completo',

      // Legal
      legalMention: 'Mención legal',
      legalAcceptance: 'Acepto los términos del contrato',
      acceptTerms: 'Confirmo haber leído y aceptado este contrato de pentest',

      // Verification
      verification: 'Verificación',
      verificationMethod: 'Método de verificación',
      smsVerification: 'Verificación por SMS',
      smsCode: 'Código SMS',
      sendCode: 'Enviar código',
      verifyCode: 'Verificar código',
      codeExpired: 'Código expirado',
      invalidCode: 'Código inválido',
      codeSent: 'Código enviado a su teléfono',

      // Metadata (DocuSign-style)
      metadata: 'Metadatos de la firma',
      signedBy: 'Firmado por',
      signedAt: 'Firmado el',
      signedAtTime: 'Hora de la firma',
      ipAddress: 'Dirección IP',
      userAgent: 'Navegador / Dispositivo',
      geolocation: 'Ubicación',

      // Certificate
      certificate: 'Certificado de firma',
      certificateOfCompletion: 'Certificado de finalización',
      signatureCertificate: 'Certificado de firma',
      downloadCertificate: 'Descargar certificado',
      viewCertificate: 'Ver certificado',

      // Integrity
      integrity: 'Integridad del documento',
      documentHash: 'Hash del documento (SHA-512)',
      signatureHash: 'Hash de la firma (SHA-512)',
      hashVerified: 'Hash verificado',
      hashMismatch: 'Error de hash',

      // Timeline / Audit
      timeline: 'Cronología',
      auditTrail: 'Registro de auditoría',
      eventLog: 'Registro de eventos',
      created: 'Creado',
      sent: 'Enviado',
      viewed: 'Visto',
      signatureStarted: 'Firma iniciada',
      signatureCompleted: 'Firma completada',

      // Success
      success: '¡Contrato firmado con éxito!',
      successMessage: 'El contrato ha sido firmado y ahora está activo.',
      thankYou: 'Gracias por su firma',

      // Errors
      error: 'Error de firma',
      errorMessage: 'No se pudo firmar el contrato',
      expired: 'Enlace de firma expirado',
      alreadySigned: 'Contrato ya firmado',
      invalidToken: 'Enlace de firma inválido'
    },

    // Actions
    send: 'Enviar para firma',
    resend: 'Reenviar',
    cancel: 'Cancelar contrato',
    download: 'Descargar PDF',
    downloadSigned: 'Descargar PDF firmado',
    preview: 'Vista previa',

    // Notifications
    sentSuccess: 'Contrato enviado para firma',
    signedSuccess: 'Contrato firmado con éxito',
    cancelledSuccess: 'Contrato cancelado'
  },

  // VPN Configuration
  vpn: {
    title: 'Configuración VPN',
    configurations: 'Configuraciones VPN',
    noConfigurations: 'Sin configuraciones VPN',
    uploadConfig: 'Subir configuración',
    connected: 'Conectado',
    disconnected: 'Desconectado',
    connecting: 'Conectando...',
    disconnecting: 'Desconectando...',
    connect: 'Conectar',
    disconnect: 'Desconectar',
    status: 'Estado VPN',
    protocol: 'Protocolo',
    interface: 'Interfaz',
    publicIp: 'IP Pública',
    vpnIp: 'IP VPN',
    country: 'País',
    city: 'Ciudad',
    connectedSince: 'Conectado desde',
    routes: {
      title: 'Rutas de Red',
      description: 'Gestionar rutas de red personalizadas para VPN',
      addRoute: 'Añadir ruta',
      destination: 'Destino CIDR',
      destinationPlaceholder: '192.168.56.0/24',
      gateway: 'Puerta de enlace',
      gatewayPlaceholder: '192.168.10.1',
      routeDescription: 'Descripción',
      routeDescriptionPlaceholder: 'Red interna del cliente',
      noRoutes: 'Sin rutas configuradas',
      deleteRoute: 'Eliminar ruta',
      applyRoutes: 'Aplicar rutas',
      routeAdded: 'Ruta añadida correctamente',
      routeDeleted: 'Ruta eliminada',
      routesApplied: 'Rutas aplicadas',
      invalidCidr: 'Formato CIDR inválido',
      invalidGateway: 'Dirección IP inválida',
      active: 'Activa',
      inactive: 'Inactiva'
    },
    topology: {
      title: 'Topología de Red',
      server: 'Servidor Sylink',
      internet: 'Internet',
      vpnGateway: 'Gateway VPN',
      clientNetwork: 'Red del Cliente',
      online: 'En línea',
      offline: 'Fuera de línea',
      activeRoutes: 'Rutas activas',
      totalRoutes: 'Rutas totales'
    },
    messages: {
      configUploaded: 'Configuración VPN subida',
      configDeleted: 'Configuración VPN eliminada',
      connectionSuccess: 'VPN conectado correctamente',
      connectionFailed: 'Error de conexión VPN',
      disconnectionSuccess: 'VPN desconectado',
      disconnectionFailed: 'Error de desconexión VPN'
    }
  }

};
